module.exports = __webpack_public_path__ + "img/026-bunny.39818a15.png";